import * as api from "api/endpoints/contractTerms";
import { createSlice, createSliceSelector } from "../factory";

const name = "contractTermsPage";

const initialState = {
  contractTermsValues: {
    partnerId: null,
    advancedMatchingEnabled: false,
    standardMatchingEnabled: false,
    bizFirmograhicEnabled: false,
    bizHealthEnabled: false,
    bizComplianceEnabled: false,
    bizHeirarchyEnabled: false,
    bizDiversityEnabled: false,
    officerNameMatchingEnabled: false,
    businessMonitoringEnabled: false,
    complianceMonitoringEnabled: false,
    businessLookupFreeRetrievalsLimit: null,
    bizDecisionEnabled: false,
    bizSearchEnabled: false
  }
};

const slice = createSlice(name, initialState);

export default slice.reducer;

/* Selectors */
const createSelector = createSliceSelector(name);

export const selectContractTermsData = createSelector((state) => {
  return state.contractTermsValues;
});

/* Actions */
const { update } = slice.actions;

export function loadContractTermsValues(epId) {
  const config = { params: { partnerId: epId } };
  return async function (dispatch) {
    api.getContractTerms(config).then((res) => {
      const payload = { contractTermsValues: res };
      dispatch(update(payload));
    });
  };
}

export function submitContractTermsValues(data) {
  return async function (dispatch) {
    api.updateContractTerms(data).then(() => {
      dispatch(loadContractTermsValues(data.partnerId));
    });
  };
}

export function updateContractTermsValues(changedValue) {
  return async function (dispatch, getState) {
    const data = selectContractTermsData(getState());

    const newValues = Object.assign({}, data, changedValue);
    const payload = {
      contractTermsValues: newValues
    };

    dispatch(update(payload));
  };
}
